<template>
  <form @submit.prevent>
    <div>
      <b-tabs v-if="showLibraryItems" justified nav-class="nav-tabs-custom" content-class="p-3 text-muted">
        <b-tab :active="showLibraryItems">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="fas fa-home"></i>
            </span>
            <span class="d-none d-sm-inline-block">{{ $t("common.library") }}</span>
          </template>
          <!--           
          <div class="pl-5 pr-5">
            <recommendation-items
              rightPanelId="sidebar-department-recommendation"
              level="department"
              libraryScopedState="department"
              organizationScopedState="organizationDepartment"
            />
          </div> -->

          <LibraryItems
            rightPanelId="sidebar-new-department"
            organizationScopedState="organizationDepartment"
            libraryScopedState="department"
            :hideAdvancedFilter="true"
          />
        </b-tab>

        <b-tab :active="isEditMode">
          <template v-slot:title>
            <span class="d-inline-block d-sm-none">
              <i class="far fa-user"></i>
            </span>
            <span class="d-none d-sm-inline-block">
              <span v-if="isEditMode">{{ $t("common.update") }}</span>
              <span v-else>{{ $t("department.new") }}</span>
            </span>
          </template>

          <sweet-input
            :isValid="!$v.form.name.$error"
            @input="$v.form.name.$touch()"
            v-model="form.name"
            type="text"
            layout="vertical"
            :placeholder="$t('department.name')"
            :label="$t('department.name')"
          />


          <!-- TKP-80 / tasarım s.11: birden çok yetkili seçilebilir; ekleme ekranında ekleyen kullanıcı ön dolu gelir.
               TKP-185 md.70b: yetkili alanı yalnız yeteneği olana (Uyum / Sistem Yöneticisi, sahip); birim yöneticisi görmez, sunucu kendisini yazar -->
          <template v-if="canSetAdmins">
          <h6 class="mt-4">{{ $t("department.admins") }}</h6>

          <organization-member-select :multiple="true" :prefill-account-id="currentAccount && currentAccount._id" @onAclSelect="onDepartmentAdminSelect" />
          <small class="text-muted">{{ $t("department.admins-hint") }}</small>
          </template>
          <!-- :permissionFilter="['ORGANIZATION_ADMIN']" -->

          <!-- TKP-64 / tasarım s.3 Öneri 2 md.3: süreç eklenebilir işareti -->
          <b-form-checkbox v-model="form.processAllowed" switch class="mt-4">{{ $t("department.process-allowed") }}</b-form-checkbox>
          <small class="text-muted">{{ $t("department.process-allowed-hint") }}</small>

          <h6 class="mt-4">{{ $t("department.parent") }}</h6>
          <filter-select id="parentFilter" ref="parentFilter" :placeholder="$t('department.select-parent')" :multiple="false" @filter="onParentSearch" :selected="form.parent" @changed="onParentSelect" />

          <sweet-button
            @click="save()"
            type="submit"
            :loading="isUpdating"
            :disabled="isUpdating || $v.$invalid"
            variant="success"
            icon="mdi mdi-check"
            size="sm"
            buttonClass="mt-2"
          >
            {{ $t("common.save") }}
          </sweet-button>
        </b-tab>
      </b-tabs>
      <div v-else>
        <h2>
          <span v-if="!showLibraryItems && isEditMode">{{ entityName }} {{ $t("common.update") }}</span>
          <span v-else>{{ $t("department.new") }}</span>
        </h2>

        <sweet-input
          :isValid="!$v.form.name.$error"
          @input="$v.form.name.$touch()"
          v-model="form.name"
          type="text"
          layout="vertical"
          :placeholder="$t('department.name')"
          :label="$t('department.name')"
        />


        <template v-if="canSetAdmins">
        <h6 class="mt-4">{{ $t("department.admins") }}</h6>

        <organization-member-select :multiple="true" @onAclSelect="onDepartmentAdminSelect" :selected="selectedAdmins" />
        <small class="text-muted">{{ $t("department.admins-hint") }}</small>
        <!-- TKP-233 m.155: birim yöneticisi süreç yöneticilerini değiştirmez — yayılma uyarısı kalktı -->
        </template>
        <small v-else class="d-block text-muted mt-4" data-test="admins-readonly">{{ $t("department.admins-readonly") }}</small>
        <!-- :permissionFilter="['ORGANIZATION_ADMIN']"  -->

        <!-- TKP-64 / tasarım s.3 Öneri 2 md.3: süreç eklenebilir işareti -->
        <b-form-checkbox v-model="form.processAllowed" switch class="mt-4">{{ $t("department.process-allowed") }}</b-form-checkbox>
        <small class="text-muted">{{ $t("department.process-allowed-hint") }}</small>

        <h6 class="mt-4">{{ $t("department.parent") }}</h6>

        <filter-select
          openDirection="top"
          id="parentFilter1"
          ref="parentFilter1"
          :placeholder="$t('department.select-parent')"
          :multiple="false"
          @filter="onParentSearch"
          :selected="form.parent"
          @changed="onParentSelect"
        />

        <sweet-button @click="save()" type="submit" :loading="isUpdating" :disabled="isUpdating || $v.$invalid" variant="success" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
          {{ $t("common.save") }}
        </sweet-button>

        <sweet-button @click="cancel()" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="mt-2 ml-2">
          {{ $t("common.cancel") }}
        </sweet-button>
        <hr />
      </div>
    </div>
  </form>
</template>

<script>
import LibraryItems from "@cc/library-items";
import OrganizationMemberSelect from "@cc/organization-member-select";
import RecommendationItems from "@cc/recommendation-items";

import { maxLength, minLength, required } from "vuelidate/lib/validators";

export default {
  // TKP-27 / K3: `presetParent` — ağaç görünümünden "alt birim ekle" ile açılınca üst birim hazır gelir
  props: { "hide-library": { type: Boolean }, closeOnSave: { type: Boolean, default: true }, presetParent: { type: Object, default: undefined } },
  components: {
    LibraryItems,
    RecommendationItems,
    OrganizationMemberSelect,
  },
  data() {
    return {
      form: { name: undefined, admins: undefined, parent: undefined, processAllowed: true },
      formError: undefined,
      entityName: undefined,
      adminChanged: false,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(350),
      },
      admins: {
        // TKP-80: en az bir yetkili kalmak zorunda; son yetkili çıkarılınca kaydetme kapalı.
        // TKP-185 md.70b: alanı göremeyen (yetkisiz) kullanıcıda kural uygulanmaz — sunucu mevcut listeyi korur / kendisini yazar
        atLeastOne() {
          return !this.canSetAdmins || (!!this.form.admins && this.form.admins.length > 0);
        },
      },
    },
  },
  watch: {
    presetParent: {
      immediate: true,
      handler(v) {
        if (v && !this.form._id) this.form = { ...this.form, parent: v };
      },
    },
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v), processAllowed: v.processAllowed !== false }; // TKP-64: alan yoksa eklenebilir
        this.entityName = this.form.name;
      },
    },
    copingEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v || Object.keys(v).length === 0) return;

        this.form = { ...this.prepareFormForEdit(v) };
        this.entityName = this.form.name;
      },
    },
  },
  computed: {
    /** TKP-185 md.70b */
    canSetAdmins() {
      return this.currentAccountCan("ENTITY_ADMINS__CAN_SET");
    },
    isUpdating() {
      return this.$store.getters["organizationDepartment/isUpdating"];
    },
    /** TKP-80: seçim kutusu artık dizi taşıyor; tek yetkili de tek elemanlı dizi. */
    selectedAdmins() {
      return (this.form.admins ?? []).map((admin) =>
        admin.account
          ? { _id: admin._id ?? admin.account._id, accountId: admin.account._id, name: admin.account.name, email: admin.account.email, avatar: admin.account.avatar }
          : { _id: admin._id ?? admin.accountId, accountId: admin.accountId, name: admin.name, email: admin.email, avatar: admin.avatar }
      );
    },
    editedEntity() {
      return this.$store.getters["organizationDepartment/editedEntity"];
    },
    copingEntity() {
      return this.$store.getters["organizationDepartment/copingEntity"];
    },
    isEditMode() {
      return this.$store.getters["organizationDepartment/isEditMode"];
    },
    showLibraryItems() {
      return !this.hideLibrary && !this.isEditMode && !this.isCoping;
    },
    isCoping() {
      return this.$store.getters["organizationDepartment/isCoping"];
    },
  },
  async mounted() {},
  methods: {
    async save() {
      const ok = await this.confirm(this.$t("alert.approve"));
      if (!ok) {
        return;
      }
      try {
        const { data } = await this.$store.dispatch("organizationDepartment/save", this.form);
        this.$store.commit("organizationDepartment/editedEntity", data);
        this.$emit("onDepartmentSave");
        this.adminChanged && this.$emit("onAdminChanged");
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-new-department");
        }
        setTimeout(() => {
          this.resetForm();
        }, 500);

        this.$toast.success(this.$t("common.success"));
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    resetForm() {
      this.form = {
        name: undefined,
        admins: undefined,
        parent: this.presetParent,
        processAllowed: true,
      };
    },
    cancel() {
      this.$store.commit("organizationDepartment/editedEntity");
      this.$store.commit("organizationDepartment/copingEntity");
      // this.$store.dispatch("organizationDepartment/resetForm");
    },
    // TKP-27 / K3: üst birim başka bir departman; kendisi listelenmez (alt ağaç kontrolü backend'de 409)
    async onParentSearch(value, callback) {
      const response = await this.$store.dispatch(`organizationDepartment/paginateForSearch`, {
        options: { limit: 50, sort: { name: "asc" } },
        query: { name: { value } },
      });

      callback((response.data?.docs ?? []).filter((d) => d._id !== this.form._id));
    },
    onParentSelect(item) {
      this.form = { ...this.form, parent: item && item._id ? item : null };
    },

    rightPanelClosed() {},
    onDepartmentAdminSelect(items) {
      // TKP-80: bileşen çoklu seçimde dizi yolluyor; tek nesne gelirse (eski çağrı biçimi) diziye sarılır.
      const admins = Array.isArray(items) ? items : items ? [items] : [];
      this.form = { ...this.form, admins };
      this.adminChanged = true;
    },
  },
};
</script>
